import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { getCountdownTemplate } from "@/assets/utilities/tinymce/shortcodes/templates";
import { parseToHtml } from "@/utility/parseToHtml";

const width = 400;
const height = 637;

const editCountdownConfig = (editor, shortcodeWrapper) => {
  let currentData = null;

  const countdownWindow = editor.windowManager.openUrl({
    title: "Countdown",
    url: "/countdown-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "add",
        text: "Add",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");
      const encodedData = btoa(unescape(encodeURIComponent(JSON.stringify(currentData))));

      shortcodeWrapper.setAttribute("data-countdown-data", encodedData);
      const shortcodeContent = shortcodeWrapper.querySelector(".countdown-shortcode");
      shortcodeContent.outerHTML = getCountdownTemplate(currentData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateCountdownData") {
        currentData = message.data;
      }
    },
    width,
    height,
  });

  const sendData = () => {
    const countdownShortcodeData = shortcodeWrapper.getAttribute("data-countdown-data");
    const parsedData = JSON.parse(decodeURIComponent(escape(window.atob(countdownShortcodeData))));

    countdownWindow.sendMessage({
      type: "sendData",
      data: parsedData,
    });
  };
};

const countdownConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Countdown",
    url: "/countdown-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "add",
        text: "Add",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getCountdownTemplate(currentData),
        "countdown-shortcode",
      );
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      const encodedData = btoa(unescape(encodeURIComponent(JSON.stringify(currentData))));

      shortcodeWrapperEl.setAttribute("data-countdown-data", encodedData);

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width,
    height,
  });
};

export { countdownConfig, editCountdownConfig };
